module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/6_63efbbb9ed87aad30b3d53115214bafa.png";